package com.neurobs.ccabserver.administrator.controller

import com.neurobs.ccab.db.ErrorClassData
import com.neurobs.js.controller.{AdminListAdapter, AdminListController, AdminPanelDelegate}
import com.neurobs.js.dom.RecordTableView
import com.neurobs.js.view.Gui
import com.neurobs.js.util.StringUtilities.dateString

import scala.concurrent.Future
import scala.concurrent.ExecutionContext.Implicits.global

class ErrorClassListController(gui: Gui, cache: RecordCache) extends AdminListAdapter[ErrorClassData] {

	override def title: String = "Error Classes"

	override def itemName: String = "Error Class"

	override def columnHeaders: Seq[RecordTableView.ColumnHeader] = Seq(
		"DID",
		"Created",
		"Identifier",
		"Description"
	)

	override def itemRow(a: ErrorClassData, delegate: Option[AdminPanelDelegate], controller: AdminListController[ErrorClassData]): Seq[RecordTableView.CellContent] = Seq(
		a.id.toString,
		dateString(a.createdAt),
		a.identifier,
		a.description
	)

	override val create: Option[AdminListController[ErrorClassData] => Unit] = None

	override def get(): Future[Either[String, Seq[ErrorClassData]]] = {
		cache.errorClasses.clear()
		cache.errorClasses.get map {
			case Left(error) => Left(error.description)
			case Right(data) => Right(data)
		}
	}
}

object ErrorClassListController {
	def apply(gui: Gui, cache: RecordCache): AdminListController[ErrorClassData] = new AdminListController[ErrorClassData](new ErrorClassListController(gui, cache))
}
